const $header = document.querySelector('[data-role=header]');

export const toggleScrolledHeader = () => {
	if (window.scrollY == 0) {
		$header?.classList?.remove('scrolled');

		return;
	}

	$header?.classList?.add('scrolled');
}; 